import type * as ents from '@attain-apps/entities'
import * as graphql from '@attain-apps/fe/web/main/lib/graphql'
import gql from 'graphql-tag'

import * as enumValueType from './enum-value-type'
import * as filesValueType from './files-value-type'
import * as intrinsicValueType from './intrinsic-value-type'
import * as referenceValueType from './reference-value-type'
import * as structureValueType from './structure-value-type'

export const DOC = gql`
  ${enumValueType.DOC}
  ${filesValueType.DOC}
  ${intrinsicValueType.DOC}
  ${referenceValueType.DOC}
  ${structureValueType.DOC}
  fragment FragmentDmsValueTypeForAttribute on DmsValueTypeForAttribute {
    __typename
    ...FragmentDmsEnumValueType
    ...FragmentDmsFilesValueType
    ...FragmentDmsIntrinsicValueType
    ...FragmentDmsReferenceValueType
    ...FragmentDmsStructureValueType
  }
`
export const TRANSFORMER = graphql.transformers.OUT.discriminateOn<
  graphql.schema.FragmentDmsValueTypeForAttributeFragment,
  ents.core.dms.models.Attribute.Type,
  '__typename'
>('__typename', {
  DmsEnumValueType: enumValueType.TRANSFORMER,
  DmsFilesValueType: filesValueType.TRANSFORMER,
  DmsIntrinsicValueType: intrinsicValueType.TRANSFORMER,
  DmsReferenceValueType: referenceValueType.TRANSFORMER,
  DmsStructureValueType: structureValueType.TRANSFORMER,
})
